import NewRcdForm from "../layout/NewRcdForm.vue";
import RcdView from "../RcdView.vue";

export const rcdRoutes = [
  {
    path: "/rcd",
    name: "rcd-view",
    component: RcdView,
    // meta: {
    //   key: 'view_rcd'
    // }
  },
  {
    path: "/rcd-new",
    name: "rcd-new",
    component: NewRcdForm,
    // meta: {
    //   key: 'view_rcd'
    // }
  },
];
